import React, { ReactNode } from 'react';
import { Box, styled, Typography, useTheme } from '@mui/material';

const BoldText = styled(Typography)(({ theme }) => ({
    fontWeight: theme.typography.fontWeightBold,
}));

const Description = styled(Typography)({
    maxWidth: '20rem',
    minHeight: '4rem',
});
export interface IntegrationsStepProps {
    title: string;
    description: string;
    children?: ReactNode;
}

const IntegrationsStep: React.FCC<IntegrationsStepProps> = (
    props: IntegrationsStepProps,
) => {
    const theme = useTheme();
    return (
        <Box flex={1} paddingX={theme.spacing(0.5)} textAlign="center">
            <Box paddingBottom={4}>
                <Box alignSelf="center" paddingBottom={2}>
                    {props.children}
                </Box>
                <BoldText variant="body2">{props.title}</BoldText>
                <Box display="flex" justifyContent="center" paddingTop={0.5}>
                    <Description variant="body2">
                        {props.description}
                    </Description>
                </Box>
            </Box>
        </Box>
    );
};

export default IntegrationsStep;
